import dayjs from '@api/services/tools/dayjs';
import { parseUrlParams, setAtEndOfDay } from '@api/services/tools/handleUrlParams';
import { getGeneralInfo } from '@api/store/account/actions';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export const useDateParamsBasedOnLogsRetention = (skipQuery = false) => {
    const location = useLocation();
    const query = parseUrlParams(location.search);
    const { KeepLogsForDays } = useSelector(getGeneralInfo);

    let from = dayjs().subtract(KeepLogsForDays, 'd');
    let to = dayjs().endOf('day').utc();

    if (!skipQuery && !!query.from && !!query.to) {
        from = dayjs(query?.from as string);
        to = dayjs(query?.to as string);
    }

    return {
        from: from.startOf('day').utc().toISOString(),
        to: setAtEndOfDay(to.toISOString()),
    };
};
